export type ScreenRect = {
  /** position + size of the device's screen, as a % of the photo */
  left: number
  top: number
  width: number
  height: number
}

export type Device = {
  id: string
  name: string
  blurb: string
  /** actual screen resolution in px — yes, really */
  width: number
  height: number
  /** photo of the whole device, screen blacked out */
  image: string
  /** photo aspect ratio, width / height */
  imageAspect: number
  screenRect: ScreenRect
  /** CSS filter applied to the video to fake the display technology */
  filter: string
  /** glow color of the lit screen */
  glow: string
}

export const devices: Device[] = [
  {
    id: 'gameboy',
    name: 'Game Boy',
    blurb: 'Four shades of swamp green, 160×144.',
    width: 160,
    height: 144,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8af3d34f-9c92-43f5-89cc-c521fa4913a9.jpg',
    imageAspect: 0.75,
    screenRect: { left: 36.6, top: 26.7, width: 26.1, height: 20.7 },
    filter: 'grayscale(1) contrast(1.7) sepia(1) hue-rotate(50deg) saturate(3.2) brightness(1)',
    glow: 'rgba(155,188,15,0.45)',
  },
  {
    id: 'nokia',
    name: 'Nokia 3310',
    blurb: 'Indestructible. 84×48 of monochrome.',
    width: 84,
    height: 48,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4a2c0bd9-92b5-4f0d-8aa4-59a04ca58d2d.jpg',
    imageAspect: 0.5625,
    screenRect: { left: 34.1, top: 34.4, width: 31.6, height: 14.3 },
    filter: 'grayscale(1) contrast(2.4) sepia(1) hue-rotate(55deg) saturate(4) brightness(1)',
    glow: 'rgba(156,168,106,0.5)',
  },
  {
    id: 'casio',
    name: 'Casio FX-82',
    blurb: 'A calculator. Playing a video. 96×31.',
    width: 96,
    height: 31,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f387ce27-a78b-498e-a1b4-60c5b6ff2731.jpg',
    imageAspect: 0.75,
    screenRect: { left: 31.8, top: 23.4, width: 36.5, height: 7.7 },
    filter: 'grayscale(1) contrast(3) brightness(1.05) sepia(0.5) hue-rotate(150deg) saturate(0.7)',
    glow: 'rgba(185,196,176,0.45)',
  },
  {
    id: 'watch',
    name: 'Casio F-91W',
    blurb: '64×24. Also tells the time, allegedly.',
    width: 64,
    height: 24,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1dea2432-129d-4b38-8f4a-be00e82116bd.jpg',
    imageAspect: 1,
    screenRect: { left: 43.8, top: 46.7, width: 12.7, height: 6.5 },
    filter: 'grayscale(1) contrast(4.5) brightness(1.15) sepia(0.4)',
    glow: 'rgba(176,184,166,0.5)',
  },
  {
    id: 'tamagotchi',
    name: 'Tamagotchi',
    blurb: '32×32. It is mostly vibes at this point.',
    width: 32,
    height: 32,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/06b5be1b-1d53-48ec-8306-1515b64070e6.jpg',
    imageAspect: 1,
    screenRect: { left: 37.3, top: 38.5, width: 25.2, height: 23.6 },
    filter: 'grayscale(1) contrast(5) brightness(1.2)',
    glow: 'rgba(207,214,195,0.5)',
  },
]
